import { Fragment, FunctionalComponent, h } from '@stencil/core';

export const LoadingAjax: FunctionalComponent = () => (
    <Fragment>
        <div class='ajax-spinner'>
            <div class="spinner" />
        </div>
    </Fragment>
);
